import { ComponentConfiguration } from './component_configuration';

export class CardColorSuitGeneratorConfiguration extends ComponentConfiguration {
  constructor(json: Record<string, any>) {
    super(json);
  }
}
